import jsonp from "jsonp";

export async function retornarDadosCnpj(cnpj) {
    return new Promise((resolve, reject) => {
        jsonp(`https://receitaws.com.br/v1/cnpj/${cnpj}`, (err, data) => {
            if (err) {
                reject(err);
            } else {
                resolve(data);
            }
        });
    });
}